import React, { useRef, useState } from 'react';
import {
  Avatar,
  Backdrop,
  Fade,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Theme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Settings, ExitToApp } from '@material-ui/icons';

interface Props {
  imageUrl: string;
  onEditProfile: () => void;
  onSignOut: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    backgroundColor: '#FFF0',
    zIndex: theme.zIndex.drawer + 1,
  },
  icon: {
    color: '#D0D7E1',
  },
  list: {
    backgroundColor: '#564F70',
    borderBottom: `4px solid ${theme.palette.secondary.main}`,
  },
  popper: {
    zIndex: theme.zIndex.drawer + 2,
  },
}));

const UserAvatar: React.FC<Props> = ({
  imageUrl,
  onEditProfile,
  onSignOut,
}) => {
  const anchorEl = useRef<HTMLDivElement | null>();
  const [open, setOpen] = useState(false);
  const { backdrop, icon, list, popper } = useStyles();
  const handleEditProfile = () => {
    setOpen(false);
    onEditProfile();
  };
  return (
    <>
      <Avatar
        src={imageUrl}
        ref={(r) => (anchorEl.current = r)}
        onClick={() => setOpen(true)}
      />
      <Backdrop className={backdrop} open={open} onClick={() => setOpen(false)}>
        <Popper
          className={popper}
          open={open}
          anchorEl={anchorEl.current}
          placement='bottom-end'
          transition
          onClick={(e) => e.stopPropagation()}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper className={list}>
                <List>
                  <ListItem button onClick={handleEditProfile}>
                    <ListItemIcon>
                      <Settings className={icon} />
                    </ListItemIcon>
                    <ListItemText>แก้ไขโปรไฟล์</ListItemText>
                  </ListItem>
                  <ListItem button onClick={onSignOut}>
                    <ListItemIcon className={icon}>
                      <ExitToApp />
                    </ListItemIcon>
                    <ListItemText>ออกจากระบบ</ListItemText>
                  </ListItem>
                </List>
              </Paper>
            </Fade>
          )}
        </Popper>
      </Backdrop>
    </>
  );
};

export default UserAvatar;
